var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feedback-container",on:{"click":_vm.toFeedbackPage}},[_c('div',{staticClass:"content"},[_c('a-icon',{attrs:{"type":"form"}}),_c('span',{staticClass:"text"},[_vm._v("反馈")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }